export const environment = {
    production: true,
    clientHost: 'https://pwcstaging.staftr.com/',
    apiUrl: 'https://pwcstaging-api.staftr.com/',
    adminAppUrl: 'https://pwcstaging-admin.staftr.com/admin',
    usSpecificTimezoneOnly: true,
    tokenRefreshBefore: -2,
    dateFormat: 'MM/dd/yyyy',
    title: "Managed Review Deployment",
    favicon: 'assets/images/favicon_pwc.ico',
    firebaseConfig :{
        apiKey: "AIzaSyAr3j3zU9oZ7OYp6ITBBgnwKUoHrEVcm7M",
        authDomain: "mplace-dd342.firebaseapp.com",
        databaseURL: "https://pwc-stage.firebaseio.com",
        projectId: "mplace-dd342",
        storageBucket: "",
        messagingSenderId: "136536185534",
        logging: true
    },
    unitTestConfig: {
        defaultPassword: "Tester@1234"
    },
    isPWCEnabled: true,
    mailToContact: 'lmsmanagedreview@PwC.onmicrosoft.com',
    privacyPolicyUrl: 'https://www.pwc.com/us/en/site/privacy.html',
    termsOfServiceUrl: 'https://www.pwc.com/us/en/site/terms-and-conditions.html'
};
